import { Component, inject } from "@angular/core";
import { UiKitModule } from "@app/ui-kit.module";
import { ToggleItemTextVisibilityButtonComponent } from "@components/toggle-item-text-visibility-button/toggle-item-text-visibility-button.component";
import { ToggleLockButtonComponent } from "@components/toggle-lock-button/toggle-lock-button.component";
import { ToggleVisibilityButtonComponent } from "@components/toggle-visibility-button/toggle-visibility-button.component";
import { FloorplanState } from "@domain/project/floorplan/floorplan-state";
import { FloorplanZonesService } from "@project/floorplan-zones.service";
import { FloorplanMenuItemButtonsComponent } from "@project/floorplanner/floorplan-menu/fgds/floorplan-menu-item-buttons/floorplan-menu-item-buttons.component";
import { FloorplanService } from "@project/floorplanner/floorplan.service";
import { DraggedItemType, FloorplanDragDropService } from "@utils/floorplan-drag-drop.service";

@Component({
  selector: "app-floorplan-danger-area-menu",
  templateUrl: "./floorplan-danger-area-menu.component.html",
  styleUrls: ["./floorplan-danger-area-menu.component.scss"],
  imports: [
    UiKitModule,
    FloorplanMenuItemButtonsComponent,
    ToggleVisibilityButtonComponent,
    ToggleLockButtonComponent,
    ToggleItemTextVisibilityButtonComponent,
  ],
})
export class FloorplanDangerAreaMenuComponent {
  private floorplanService = inject(FloorplanService);
  private floorplanZonesService = inject(FloorplanZonesService);
  private dragDropService = inject(FloorplanDragDropService);

  protected floorplanState: FloorplanState;
  protected readonly tooltipText: string = $localize`:@@floorplan.button.addDangerArea:Gefahrenbereich platzieren`;

  constructor() {
    this.floorplanState = this.floorplanService.selectedFloorplan.floorplanState;
  }

  protected addDangerArea() {
    this.floorplanZonesService.addDangerArea();
  }

  protected dragDangerArea() {
    this.dragDropService.setDragged({ type: DraggedItemType.DANGER_AREA });
  }

  protected updateDangerAreasItemTextVisibility(visible: boolean) {
    this.floorplanState.updateDangerAreasItemTextVisibility(visible);
  }
}
